import { createAsyncThunk } from '@reduxjs/toolkit';
import { GET_RAIDOLOGIEST_DATA } from '@custom/constant';

const fetchRadiologistUser = createAsyncThunk('radiologistUser/fetch', async () => {
  try {
    const url = GET_RAIDOLOGIEST_DATA;
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    // Check if the response is ok
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Return the response data
    return await response.json();
  } catch (error) {
    // Handle and return the error
    return Promise.reject(error);
  }
});

export default fetchRadiologistUser;
